import {
  HappycoPropertiesQuery,
  HappycoPropertiesQueryVariables,
  HappycoPropertyFragment,
} from "gql/graphql";
import React, { memo, useCallback, useMemo } from "react";
import { useQuery } from "@apollo/client";
import HAPPYCO_PROPERTIES_QUERY from "./_networking/happyco-properties";
import { Select, SingleValue } from "chakra-react-select";
import { SystemStyleObject } from "@chakra-ui/react";
import colors from "app/colors";

interface IProps {
  onPropertySelected: (
    happycoProperty?: SingleValue<HappycoPropertyFragment>,
  ) => void;
}

const HappycoPropertySelector = ({ onPropertySelected }: IProps) => {
  const { data } = useQuery<
    HappycoPropertiesQuery,
    HappycoPropertiesQueryVariables
  >(HAPPYCO_PROPERTIES_QUERY);

  const onChange = (happycoProperty: SingleValue<HappycoPropertyFragment>) => {
    onPropertySelected(happycoProperty);
  };

  const getOptionLabel = useCallback(
    (happycoProperty: HappycoPropertyFragment) => happycoProperty.name,
    [],
  );

  const getOptionValue = useCallback(
    (happycoProperty: HappycoPropertyFragment) => happycoProperty.happycoId,
    [],
  );

  const happycoProperties = useMemo(
    () => data?.happycoProperties || [],
    [data],
  );

  return (
    <Select
      options={happycoProperties}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      placeholder="Select Property"
      onChange={onChange}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      chakraStyles={{
        placeholder: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          fontStyle: "italic",
          color: colors.placeholderText,
          fontSize: 14,
        }),
        container: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          width: "full",
          borderColor: colors.grayPrimary,
        }),
        control: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          minHeight: "34px",
        }),
      }}
    />
  );
};

export default memo(HappycoPropertySelector);
